import React from 'react'

type Props = {
  className?: string
  fillColor?: string
  size?: number
}

// Outlined book (FA5 Regular shape — open book with binding down the middle
// and trailing page indicator on the right). Drawn as stroked paths so it
// renders as a true line icon rather than a filled silhouette. `size`
// matches the pattern in components/Icons/Copy.tsx — the only existing
// icon in this directory that exposes a size knob; mirroring it here so
// future icons can converge on a single sizing convention.
const BookOutline = ({
  className,
  fillColor = 'currentColor',
  size = 16,
}: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    stroke={fillColor}
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
)

export default BookOutline
